var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSettingButton(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 53,
    height: 53,
    viewBox: "0 0 53 53",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u30B0\\u30EB\\u30FC\\u30D7_15770",
    "data-name": "\\u30B0\\u30EB\\u30FC\\u30D7 15770",
    transform: "translate(-1723 -15)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u30B0\\u30EB\\u30FC\\u30D7_15768",
    "data-name": "\\u30B0\\u30EB\\u30FC\\u30D7 15768"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u30B0\\u30EB\\u30FC\\u30D7_15767",
    "data-name": "\\u30B0\\u30EB\\u30FC\\u30D7 15767",
    transform: "translate(17669 -6437)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_21867",
    "data-name": "\\u30D1\\u30B9 21867",
    d: "M0,0H53V53H0Z",
    transform: "translate(-15946 6452)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "setting",
    d: "M71.429,62.65a8.328,8.328,0,0,0,.068-1.332c0-.466-.068-.865-.068-1.332l2.86-2.2a.612.612,0,0,0,.136-.865L71.7,52.329a.663.663,0,0,0-.817-.267l-3.405,1.332a9.913,9.913,0,0,0-2.315-1.332l-.477-3.529A.73.73,0,0,0,64.005,48H58.557a.73.73,0,0,0-.681.533l-.545,3.529a11.533,11.533,0,0,0-2.316,1.332L51.61,52.062a.638.638,0,0,0-.817.267l-2.724,4.595a.8.8,0,0,0,.136.865l2.929,2.2c0,.466-.068.865-.068,1.332s.068.865.068,1.332l-2.86,2.2a.612.612,0,0,0-.136.865l2.724,4.595a.663.663,0,0,0,.817.267l3.405-1.332A9.912,9.912,0,0,0,57.4,70.574l.545,3.529a.66.66,0,0,0,.681.533h5.448a.73.73,0,0,0,.681-.533l.545-3.529a11.527,11.527,0,0,0,2.315-1.332l3.405,1.332a.638.638,0,0,0,.817-.267l2.724-4.595a.8.8,0,0,0-.136-.865l-3-2.2ZM61.281,65.979a4.662,4.662,0,1,1,4.767-4.661A4.686,4.686,0,0,1,61.281,65.979Z",
    transform: "translate(-15980.998 6416.999)",
    fill: "#fff"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettingButton);
export default __webpack_public_path__ + "static/media/settingButton.78f1af6e6340ed1804c7209c4aef86f9.svg";
export { ForwardRef as ReactComponent };